// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__iIKC2","col":"Table_col__1qZAn","fulfillmentStatus":"Table_fulfillmentStatus__2yahG","emailCol":"Table_emailCol__1uLVk"};